export enum ProviderStatusType {
  Pending = 0,
  Created = 1,
  Billable = 2,
}
